var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.64514015031c1918c402af236081b654.svg#t';
                    var viewUrl = 'sprites.64514015031c1918c402af236081b654.svg#view-t';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };